export default __webpack_public_path__ + "static/media/banner_3_3_11zon.979a0a2b.webp";